import NextStepButton from './next-step-button.vue';

export default NextStepButton;
